import React, { useContext } from "react";
import { observer } from "mobx-react";

import { BetOffer } from "@models/BetOffer";

import { BetSlipShareDetails } from "@state/stores/my-bets/BetSlipShareDetailsStore";
import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";
import EventDataWrapper from "@features/my-bets/desktop/common/EventDataWrapper";
import BetOfferItemTip from "@features/my-bets/desktop/common/BetOfferItemTip";
import BetOfferItemOfferResults from "@features/my-bets/desktop/common/BetOfferItemOfferResults";

export default observer(function BetOfferItem(props: { offer: BetOffer }) {
	const store = useContext(MyBetsStoreContext);

	if (!(store instanceof BetSlipShareDetails)) {
		return null;
	}

	return (
		<tr className="table__tr">
			<td className="table--bets__td table--bets__td--combi">
				{(store.bet?.betSlipCombinations?.length || 0) > 0
					? props.offer.systemIdentifier
					: ""}
			</td>
			<EventDataWrapper offer={props.offer} />
			<td className="table--bets__td table--bets__td--bank">
				{props.offer.isBank === true && (
					<span className="tag tag--tny tag--success u-padd--x--nano">
						B
					</span>
				)}
			</td>
			<BetOfferItemTip offer={props.offer} />
			<td
				className={`table--bets__td table--bets__td--odds u-color--offer--${props.offer.formattedBettingOfferStatus}`}
			>
				{props.offer.value.toFixed(2)}
			</td>
			<td className="table--bets__td table--bets__td--results">
				<BetOfferItemOfferResults offer={props.offer} />
			</td>
			<td className="table--bets__td table--bets__td--icon">
				<i
					className={`u-icon u-icon--tny u-icon--offer u-icon--offer--${props.offer.formattedBettingOfferStatus}`}
				/>
			</td>
		</tr>
	);
});
